export enum PageRoutes {
    Welcome = '/',
    Archive = '/archive',
    Tickets = '/tickets',
    Links = '/links',
    Playlists = '/playlists',
    Videos = '/videos',
    Other = '/other',
    None = '/none',
    Plan = '/plan',
    Login = '/login',
    Admin = '/admin',
    LegalNotices = '/legal-notices',
}
